import { render, staticRenderFns } from "./GameSidebar.vue?vue&type=template&id=396de7a2&scoped=true"
import script from "./GameSidebar.vue?vue&type=script&lang=js"
export * from "./GameSidebar.vue?vue&type=script&lang=js"
import style0 from "./GameSidebar.vue?vue&type=style&index=0&id=396de7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396de7a2",
  null
  
)

export default component.exports